import {
  GET_CLIENT_BENEFIT_CONFIG,
  GET_CLIENT_BENEFIT_CONFIG_SUCCESS,
  GET_CLIENT_BENEFIT_CONFIG_ERROR,
  GET_CLIENT_BENEFIT_CONFIG_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetClientBenefitConfig = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_BENEFIT_CONFIG:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_BENEFIT_CONFIG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_CLIENT_BENEFIT_CONFIG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_BENEFIT_CONFIG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetClientBenefitConfig;
